import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../../components/Layout';
import { OneTrustContent } from '../../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../../components/SEOData';

const USRecruitingPrivacyPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="US Recruiting Privacy Policy | Stitch Fix"
        robots="noindex, nofollow"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="cc58b9d6-df49-4458-8d3d-97704758c9b1" />
      </ResponsiveSection>
    </Layout>
  );
};

export default USRecruitingPrivacyPage;
